export default __webpack_public_path__ + "static/media/desktop_logo.dcb5226b.svg";